module.exports = __webpack_public_path__ + "media/advantage/PXL_20240411_144711701-842850fa.jpg";